/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';

import MoreInformation from '@components/more-information';
import Icon from '@components/icon-component';

import style from './style.module.scss';
import { decodeToken } from '@utilities/authentication';

import PermissionRestrict from 'hoc/permission-restrict';
import { PERMISSIONS } from 'permissions/constants';
import DataSnippets from '@components/data-snippet';
import { useNavigate } from 'react-router-dom';

const EquipmentDetailsMoreInfo = ({
  moreInfoDataPointsMap,
  setEditEquipment,
  moreInfoOfVessel,
  moreInfoOfPSVs,
  otherCategories,
  editEquipmentBtnEvent
}) => {
  const navigate = useNavigate();

  const permissions = decodeToken()?.permissions || {};
  const [clickLink, setClickLink] = useState(null);

  const openInDesktop = ({ link }) => {
    navigate(`${link}`);
  };

  const canEdit = useMemo(() => {
    if (permissions) return permissions[PERMISSIONS.MOBILE_CREATEEDIT_EQUIPMENT] ? true : false;
    else return false;
  }, [permissions, PERMISSIONS]);

  const infoTab = document.getElementById('assets-counts-in-nav-tabs-info') || null;

  useEffect(() => {
    if (infoTab) {
      infoTab.innerText = 'Info';
    }
  }, [infoTab]);

  return (
    <div className={style.addMarginBottom}>
      <MoreInformation
        info={Object?.keys(moreInfoDataPointsMap)?.map((a) => {
          return {
            title: moreInfoDataPointsMap[a]?.value || null,
            heading: moreInfoDataPointsMap[a]?.title || null
          };
        })}
        canEdit={canEdit}
        editBtnEvent={editEquipmentBtnEvent}
      />

      {moreInfoOfVessel?.length > 0 || moreInfoOfPSVs?.length > 0 ? (
        <div className={style.divider}>
          <p>Attached</p>
        </div>
      ) : (
        <></>
      )}

      {moreInfoOfVessel?.length > 0 ? (
        <div className={style.moreInfoBody}>
          {moreInfoOfVessel?.map((moreInfoOfPSV, index) => {
            return (
              <div key={index} className={style.test}>
                <div className={style.content}>
                  <span className={style.title}>{moreInfoOfPSV.title}</span>
                  <span className={style.name}>
                    <div>{moreInfoOfPSV.name}</div>
                    <Icon
                      name={'feather-link'}
                      height={14}
                      width={14}
                      onClick={() => {
                        clickLink === moreInfoOfPSV.id
                          ? setClickLink(null)
                          : setClickLink(moreInfoOfPSV.id);
                      }}
                    />
                  </span>

                  <DataSnippets
                    dataPoints={moreInfoOfPSV.dataPoints || []}
                    subTitleClassName={style.subTitleClassName}
                  />

                  {clickLink === moreInfoOfPSV.id && (
                    <div
                      className={style.showLink}
                      onClick={(e) => {
                        e?.stopPropagation();
                        openInDesktop({
                          link: `/equipment-details/${moreInfoOfPSV.id}`
                        });
                        setClickLink(null);
                      }}
                    >
                      <div>
                        <Icon name={'map-pin'} />
                        <p>Go to equipment</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}

      {moreInfoOfPSVs?.length > 0 ? (
        <div className={style.moreInfoBody}>
          {moreInfoOfPSVs?.map((moreInfoOfPSV, index) => {
            return (
              <div key={index} className={style.test}>
                <div className={style.content}>
                  {moreInfoOfPSV.title && (
                    <span className={style.title}>{moreInfoOfPSV.title}</span>
                  )}
                  {moreInfoOfPSV.name && (
                    <span className={style.name}>
                      <div>{moreInfoOfPSV.name}</div>
                      <Icon
                        name={'feather-link'}
                        height={14}
                        width={14}
                        onClick={() => {
                          clickLink === moreInfoOfPSV.id
                            ? setClickLink(null)
                            : setClickLink(moreInfoOfPSV.id);
                        }}
                      />
                    </span>
                  )}
                  <DataSnippets
                    dataPoints={moreInfoOfPSV.dataPoints || []}
                    subTitleClassName={style.subTitleClassName}
                  />

                  {clickLink === moreInfoOfPSV.id && (
                    <div
                      className={style.showLink}
                      onClick={(e) => {
                        e?.stopPropagation();
                        openInDesktop({
                          link: `/equipment-details/${moreInfoOfPSV.id}`
                        });
                        setClickLink(null);
                      }}
                    >
                      <div>
                        <Icon name={'map-pin'} />
                        <p>Go to equipment</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}

      {otherCategories?.length > 0 ? (
        <>
          <div className={style.divider}>
            <p>More info</p>
          </div>
          <div className={style.moreInfoBody}>
            {otherCategories?.map((x, index) => {
              return (
                <div key={index}>
                  <div className={style.content}>
                    {x.title && x.value && (
                      <>
                        <div className={style.customTitle}>{x.title}</div>
                        <div className={style.customValue}>{x.value}</div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default EquipmentDetailsMoreInfo;
